import { HttpService } from '@/shared/services'
import ClientList from '../models/ClientList'
import CompanyIntegration from '../models/CompanyIntegration'
import {
  ClientIntegrationDto,
  CreateClientDto,
  UpdateClientDto,
} from './interfaces'
import Client from '../models/Client'

const http = new HttpService()

export const getClients = async (
  search?: string,
  limit?: number,
  offset?: number
) => {
  let response

  if (limit) {
    response = await http.get<ClientList>(
      `client?limit=${limit}&offset=0&search=${search}`
    )

    return response.data
  }

  if (limit && offset) {
    response = await http.get<ClientList>(
      `client?limit=${limit}&offset=${offset}&search=${search}`
    )

    return response.data
  }

  response = await http.get<ClientList>(
    `client?limit=10&offset=0&search=${search}`
  )

  return response.data
}

export const getIntegratons = async () => {
  const response = await http.get<any>(`integration?limit=10&offset=0`)
  return response.data.data
}

export const getCompanies = async (integrationFields: ClientIntegrationDto) => {
  const response = await http.post<ClientIntegrationDto, CompanyIntegration[]>(
    `client/integration`,
    integrationFields
  )
  return response.data
}

export const createClient = async (client: CreateClientDto) => {
  const response = await http.post<CreateClientDto, string>('/client', client)
  return response.data
}

export const getClientById = async (id: string) => {
  const response = await http.get<Client>('/client/' + id)
  return response.data
}

export const deleteClientById = async (id: string) => {
  const response = await http.delete('/client/' + id)
  return response.data
}

export const inactivateToggleClient = async (id: string) => {
  const response = await http.patch('/client/inactivate/' + id)
  return response.data
}

export const updateClient = async (id: string, data: UpdateClientDto) => {
  const response = await http.put<UpdateClientDto, string>(
    '/client/' + id,
    data
  )
  return response.data
}
